module.exports = __webpack_public_path__ + "img/import-manual.7e75fab2.gif";